export default "__VITE_ASSET__DMA9GMtT__"